module.exports = __webpack_public_path__ + "img/game-logo.f0b30986.png";